import React from 'react';
import { Link } from 'react-router-dom';

const SingleFeature = (props) => {
  const { itemClass, icon, title, description } = props;
  return (
    <div className={itemClass ? itemClass : 'it-feature-item text-center'}>
      <div className="z-index">
        <div className="it-feature-icon">
          <span>
            <i className={icon ? icon : 'flaticon-brain'}></i>
          </span>
        </div>
        <div className="it-feature-content">
          <h4 className="it-feature-title">
            <Link className="hover-anim white" to="/service-details">
              {title ? title : 'Specialized Therapy and Support'}
            </Link>
          </h4>
          <p>
            {description
              ? description
              : 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim'}
          </p>
        </div>
      </div>
    </div>
  );
};

export default SingleFeature;
